import { render, staticRenderFns } from "./CollectModel.vue?vue&type=template&id=655e79fd&scoped=true"
import script from "./CollectModel.vue?vue&type=script&lang=js"
export * from "./CollectModel.vue?vue&type=script&lang=js"
import style0 from "./CollectModel.vue?vue&type=style&index=0&id=655e79fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e79fd",
  null
  
)

export default component.exports